import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { CachedUserDetails, ViEvent } from './events.model';
import { ViError } from '@vi-iot/client/models';

export namespace EventsActions {
  export enum Type {
    LOAD_EVENTS = '[EVENTS] Load Events',
    LOAD_EVENTS_SUCCESS = '[EVENTS] Load Events Success',
    LOAD_EVENTS_ERROR = '[EVENTS] Load Events Error',
    UPDATE_FILTERS = '[EVENTS] Update Filters',
    RESET_EVENTS = '[EVENTS] Reset Events',
    LOAD_USER_DETAILS = '[EVENTS] Load User Details',
    LOAD_USER_DETAILS_SUCCESS = '[EVENTS] Load User Details Success',
    LOAD_USER_DETAILS_ERROR = '[EVENTS] Load User Details Error',
  }

  export const loadEvents = createAction(Type.LOAD_EVENTS);

  export const loadEventsSuccess = createAction(
    Type.LOAD_EVENTS_SUCCESS,
    props<{
      eventsList: ViEvent[];
      cursor: string | null;
    }>()
  );

  export const loadEventsError = createAction(Type.LOAD_EVENTS_ERROR);

  export const updateFilters = createAction(
    Type.UPDATE_FILTERS,
    props<{
      filters: string[];
      dateFilter: string;
    }>()
  );

  export const resetEvents = createAction(Type.RESET_EVENTS);

  export const loadUserDetails = createAction(
    Type.LOAD_USER_DETAILS,
    props<{
      uuid: string;
    }>()
  );

  export const loadUserDetailsSuccess = createAction(
    Type.LOAD_USER_DETAILS_SUCCESS,
    props<{
      userDetails: CachedUserDetails;
    }>()
  );

  export const loadUserDetailsError = createAction(Type.LOAD_USER_DETAILS_ERROR);

  export const triggerEventLogFileGeneration = createActionGroup({
    source: 'EVENTS Trigger event log generation',
    events: {
      attempt: emptyProps(),
      success: props<{ processId: string; installationId: number }>(),
      error: props<{ error: ViError }>(),
      cleanup: emptyProps(),
    },
  });

  export const downloadEventLogFile = createActionGroup({
    source: 'EVENTS Download event log file',
    events: {
      attempt: props<{ processId: string; installationId: number }>(),
      error: props<{ error: ViError }>(),
      success: emptyProps(),
    },
  });
}
